// Import Dependencies
import { ViewColumnsIcon, XMarkIcon } from "@heroicons/react/24/outline";

// Local Imports
import { TableSettings } from "components/shared/table/TableSettings";
import { ResponsiveFilter } from "components/shared/table/ResponsiveFilter";
import { useBreakpointsContext } from "app/contexts/breakpoint/context";

// ----------------------------------------------------------------------

export function TableConfig({ table }) {
  const { smAndDown } = useBreakpointsContext();
  return (
    <ResponsiveFilter
      anchor={{ to: "left", padding: 60, gap: 10 }}
      buttonContent={
        <>
          <ViewColumnsIcon className="size-4 shrink-0" />
          <span className="hidden sm:inline">View</span>
        </>
      }
      classNames={{
        button: "border-solid shrink-0",
      }}
    >
      {({ close }) => (
        <>
          {smAndDown ? (
            <div className="dark:border-dark-500 mx-auto flex h-12 w-full shrink-0 items-center justify-between border-b border-gray-200 px-4">
              <p className="dark:text-dark-50 text-start text-base font-semibold text-gray-800">
                Table View
              </p>
              <button
                type="button"
                onClick={close}
                className="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-dark-600 dark:hover:text-gray-200 transition-colors"
                title="Close"
              >
                <XMarkIcon className="size-5 stroke-[2.5]" />
              </button>
            </div>
          ) : (
            <h3 className="text-sm-plus dark:text-dark-100 px-3 pt-2.5 font-medium tracking-wide text-gray-800">
              Table View
            </h3>
          )}

          <div className="flex flex-col flex-1 min-h-0 max-sm:overflow-hidden sm:w-64">
            <TableSettings table={table} />
          </div>
        </>
      )}
    </ResponsiveFilter>
  );
}
